// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___ce58f24f99e2b8da4dd","cls2":"SimplePaperPodcast-cls2__c9c6f6d529f6baa1a062 SimplePaperPodcast-cls1___ce58f24f99e2b8da4dd"};